import SingleLogout from './SingleLogout';

export default SingleLogout;
